/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GroupCreateRequest {
  locked?: boolean;
  name: string;
  note?: string | null;
  context?: object | null;
  defaultWorkflowId?: string | null;
}

export function GroupCreateRequestFromJSON(json: any): GroupCreateRequest {
  return GroupCreateRequestFromJSONTyped(json);
}

export function GroupCreateRequestFromJSONTyped(json: any): GroupCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    name: json["name"],
    note: json["note"],
    context: json["context"],
    defaultWorkflowId: json["default_workflow_id"],
  };
}

export function GroupCreateRequestToJSON(
  value: GroupCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    name: value.name,
    note: value.note,
    context: value.context,
    default_workflow_id: value.defaultWorkflowId,
  };
}
